const msBeforeRefresh = 30 * 1000; // 30 seconds

class Auth {
  static _singleton = null;

  static getInstance() {
    if (!this._singleton) {
      this._singleton = new Auth();
    }
    return this._singleton;
  }

  constructor(token) {
    if (token) {
      this.authenticate(token);
    } else {
      this._access_token = '';
      this._expires = 0;
      this._refresh_token = '';
      this._data = null;
    }
  }

  _setupTimers() {
    if (this !== Auth._singleton) return;
    if (this._refreshTimeout) clearTimeout(this._refreshTimeout);
    if (this._expiresTimeout) clearTimeout(this._expiresTimeout);
    const refreshDelay = Math.max((this._expires*1000) - Date.now() - msBeforeRefresh, 0);
    const expiresDelay = Math.max((this._expires*1000) - Date.now(), 0);
    this._refreshTimeout = setTimeout(this._refreshToken.bind(this), refreshDelay);
    this._expiresTimeout = setTimeout(this._onTokenExpired.bind(this), expiresDelay);
  }

  setOnTokenExpiredCallback(cb) {
    this._onTokenExpiredCallback = cb;
  }

  _onTokenExpired() {
    if (this._onTokenExpiredCallback) this._onTokenExpiredCallback({expires: this._expires});
  }

  setRefreshTokenCallback(cb) {
    this._refreshTokenCallback = cb;
  }

  _refreshToken() {
    if (this._refreshTokenCallback) this._refreshTokenCallback({expires: this._expires, refresh_token: this._refresh_token});
  }

  isAuthenticated() {
    if (!this._access_token) return false;
    if (Date.now() >= (this._expires*1000)) {
      return false;
    }
    if (!this._data || !this._data.permissions || !this._data.permissions.length) {
      return false;
    }
    //TODO handle 403 (permission denied) differently from 401 (not authenticated)
    if (!this._data.permissions.find(x => x.split(':')[0] === 'inv')) {
      return false;
    }
    return true;
  }

  authenticate(token) {
    if (!token) throw new Error("token is missing");
    if (typeof token !== 'object') throw new TypeError("token must be an object");
    this._access_token = token.access_token;
    this._expires = token.expires;
    this._refresh_token = token.refresh_token;
    const parts = this._access_token.split('.');
    this._data = JSON.parse(atob(parts[1]));
    this._setupTimers();
  }

  logout() {
    this._refresh_token = '';
    this._access_token = '';
    this._expires = 0;
    this._data = null;
    if (this._refreshTimeout) clearTimeout(this._refreshTimeout);
    if (this._expiresTimeout) clearTimeout(this._expiresTimeout);
  }

  getAccessToken() {
    return this._access_token;
  }

  hasPermission(permission) {
    if (!this._data) return false;
    return !!this._data.permissions.find(x => x === 'inv:' + permission);
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/services/auth.js